import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { BackgroundLayer } from "./components/BackgroundLayer";
import { LogoIntro } from "./components/LogoIntro";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Projects } from "./components/Projects";
import { About } from "./components/About";
import { Stats } from "./components/Stats";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

function HomePage() {
  const [heroProgress, setHeroProgress] = useState(0);
  const [pageProgress, setPageProgress] = useState(0);

  useEffect(() => {
    setPageProgress(Math.max(heroProgress, heroProgress >= 1 ? 0.75 : heroProgress * 0.75));
  }, [heroProgress]);

  useEffect(() => {
    const onScroll = () => {
      const h = window.innerHeight * 1.1;
      if (window.scrollY > h) {
        setPageProgress(0.75);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="App relative">
      <BackgroundLayer scrollProgress={pageProgress} />
      <LogoIntro />
      <Header />
      <main className="relative z-10">
        <Hero onScrollProgress={setHeroProgress} />
        <Services />
        <Projects />
        <About />
        <Stats />
        <Contact />
        <Footer />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
